import React from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", end: true, testid: "admin-nav-dashboard" },
  { to: "/admin/system", label: "System", testid: "admin-nav-overview" },
  { to: "/admin/imports", label: "Imports", testid: "admin-nav-imports" },
  { to: "/admin/listings", label: "Listings", testid: "admin-nav-listings" },
  { to: "/admin/failed-mappings", label: "Failed mappings", testid: "admin-nav-failed" },
  { to: "/admin/image-health", label: "Image health", testid: "admin-nav-image-health" },
  { to: "/admin/dealflow-debug", label: "DealFlow debug", testid: "admin-nav-dealflow-debug" },
  { to: "/admin/referrals", label: "Referrals", testid: "admin-nav-referrals" },
  { to: "/admin/referral-codes", label: "Referral Codes", testid: "admin-nav-referral-codes" },
  { to: "/admin/users", label: "Users", testid: "admin-nav-users" },
  { to: "/admin/leads", label: "Partner Leads", testid: "admin-nav-leads" },
  { to: "/admin/operations", label: "Operations", testid: "admin-nav-operations" },
  { to: "/admin/iap-monitor", label: "IAP Monitor", testid: "admin-nav-iap-monitor" },
  { to: "/admin/country-backfill", label: "Country Backfill", testid: "admin-nav-country-backfill" },
  { to: "/admin/query-learning", label: "Query Learning", testid: "admin-nav-query-learning" },
  // Batch 4 Section F — Quality Dashboard
  { to: "/admin/quality", label: "Quality", testid: "admin-nav-quality" },
  // V4.9 Phase 7 — Suspicious Listings Quarantine Queue
  { to: "/admin/suspect-queue", label: "Quarantäne", testid: "admin-nav-suspect-queue" },
];

export default function AdminLayout() {
  const { user } = useAuth();
  return (
    <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-8" data-testid="admin-layout">
      <aside className="md:sticky md:top-20 h-fit">
        <div className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-3 space-y-1">
          <div className="px-2 pb-2 border-b border-zinc-800 mb-2">
            <div className="text-[10px] uppercase tracking-widest text-emerald-400 font-mono">
              admin console
            </div>
            <div className="text-xs text-zinc-400 truncate" title={user?.email}>
              {user?.email || "—"}
            </div>
          </div>
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={item.testid}
              className={({ isActive }) =>
                `block px-3 py-2 rounded-md text-sm transition-colors ${
                  isActive
                    ? "bg-emerald-500/10 text-emerald-200 border border-emerald-500/40"
                    : "text-zinc-300 hover:bg-zinc-800/60"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <div className="pt-2 mt-2 border-t border-zinc-800">
            <Link
              to="/dashboard"
              data-testid="admin-back-to-user"
              className="block px-3 py-2 rounded-md text-xs text-zinc-500 hover:text-zinc-200 hover:bg-zinc-800/60"
            >
              ← Back to user dashboard
            </Link>
          </div>
        </div>
      </aside>
      <section className="min-w-0">
        <Outlet />
      </section>
    </div>
  );
}
